import { createListenerMiddleware } from '@reduxjs/toolkit';
import { idleDidLeave } from 'console/idle/reducer';
import { requestImportantEvents } from 'console/redux/main-actions';
import { requestNews } from 'console/redux/news/actions';
import { getAccount } from 'console/account/redux/action';
import { reloadDevice } from 'console/device/reload-device';
import { requestDeviceSpec } from 'console/redux/device_spec/actions';
export const listenerMiddleware = createListenerMiddleware();
listenerMiddleware.startListening({
    actionCreator: idleDidLeave,
    effect: (action, listenerApi) => {
        // @ts-ignore
        listenerApi.dispatch(reloadDevice());
        // @ts-ignore
        listenerApi.dispatch(requestImportantEvents());
        // @ts-ignore
        listenerApi.dispatch(requestNews());
        // @ts-ignore
        listenerApi.dispatch(getAccount());
        // @ts-ignore
        listenerApi.dispatch(requestDeviceSpec());
    },
});
